import { MRT_ColumnDef, MRT_RowData } from "material-react-table";
import {
  ButtonFileComponente,
  CustomSearch,
  EstadoComponente,
} from "@/shared/components/ui";
import {
  useUpdateSolicitudesEgresos,
  useFetchSolicitudesEgreso,
  useCreateEgresos,
} from "@/shared/actions/erp";
import {  useTableColumnsProducto, useTableFilter } from "@/shared/hooks";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import {
  AlertSeverityEnum,
  EstadosSolicitudPeodidoEnum,
  MaterialTransferido
} from "@/shared/interfaces";
import { Box, Button, Checkbox, Grid, IconButton, TextField, Tooltip, Typography, } from "@mui/material";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useEffect, useState } from "react";
import { SampleTable, SingleButton } from "@/shared/components/ui";
import { useUiStore } from "@/store/ui";
import { useMemo, useCallback } from "react";
import {
  MaterialesKey,
  useCargarSeries,
  useMaterialesUtilizadosStore
} from "@/store/erp";
import { useNavigate } from "react-router-dom";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import { useForm } from "react-hook-form";
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { gridSizeMdLg3, texto } from "@/shared";
import { SolicitudesEgreso } from "@/shared/interfaces/erp/compras/solicitudes-egreso.interface";

export default function SolicitudPedidosPrevAbiertosPagina() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const returnUrlSp = "/inventario/solicitudes-all-actions";
  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);
  const setConfirmDialogIsOpen2 = useUiStore((s) => s.setConfirmDialogIsOpen);
  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);
  const [details, setDetails] = useState<MaterialTransferido[]>([]);
  const [egreso, setEgresos] = useState({ bodega: '', ubicacion: '' });
  const [isApproved, setIsApproved] = useState(false);
  const addSinSeriesItem = useMaterialesUtilizadosStore((s) => s.addProductoSinSeriesItem);
  const clearProductoSinSeriesItems = useMaterialesUtilizadosStore((s) => s.clearProductoSinSeriesItems);
  const clearProductoSeriesItems = useMaterialesUtilizadosStore((s) => s.clearProductoSeriesItems);
  const [idEdit, setIdEdit] = useState<string | null>(null);
  const { columnsCargarSeries } = useTableColumnsProducto();
  const updateSelectedItemQuantity = useMaterialesUtilizadosStore(s => s.updateSelectedItemQuantity);
  const [openModalSeries, setOpenModalSeries] = useState<boolean>(false);
  const [visibleComponente, setVisibleComponente] = useState({ isArchivo: true });


  const updateSolicitudesPedidos = useUpdateSolicitudesEgresos({
    navigate,
    returnUrl: returnUrlSp
  });

  const createEgresos = useCreateEgresos({
    navigate,
    returnUrl: returnUrlSp,
  })
  const updateQuantityProductoItem = useMaterialesUtilizadosStore(s => s.updateQuantityProductoItem);

  const onChangeQuantity = useCallback(
    (value: number, item: any) => {
      // Convertir a números ya que los valores parecen ser cadenas
      const cantidad_previamente_despachada = Number(item.cantidad_previamente_despachada);
      const cantidad_total = Number(item.cantidad_total);

      // Actualizar los valores
      const new_cantidad_previamente_despachada = isApproved ? cantidad_previamente_despachada + value : cantidad_previamente_despachada;
      const new_cantidad_total = cantidad_total - value;

      // Aquí es donde actualizarías tus datos, por ejemplo:
      updateQuantityProductoItem(
        {
          ...item,
          cantidad_recibida: value.toString(),
          cantidad_previamente_despachada: new_cantidad_previamente_despachada.toString(),
          cantidad_total: new_cantidad_total.toString(),
        },
        MaterialesKey.solicitudesPedidosSinSeries
      );
    },
    [updateQuantityProductoItem, isApproved]
  );

  const onChangeSeries = useCallback(
    (value: boolean, item: any) => {
      updateSelectedItemQuantity(
        { ...item, contiene_serie: value, series: value ? item.series : [] },
        MaterialesKey.solicitudesPedidosSinSeries
      );
    },
    [updateSelectedItemQuantity]
  );
  const form = useForm();

  const proceedWithSave = () => {
    // Verificar si todas las cantidades recibidas son iguales a las solicitadas
    const allApproved = details.every(
      (detail) => detail.cantidad === detail.cantidad_recibida
    );

    // Verificar si todas las cantidades recibidas son 0
    const allZero = details.every((detail) => Number(detail.cantidad_recibida!) === 0);


    // Si todas las cantidades recibidas son 0, el estado es 'EN ESPERA'
    // Si todas las cantidades recibidas son iguales a las solicitadas, el estado es 'APROBADAS'
    // De lo contrario, es 'DESPACHADO'
    let estado;
    if (allZero) {
      estado = EstadosSolicitudPeodidoEnum.ABIERTO;
    } else if (allApproved) {
      estado = EstadosSolicitudPeodidoEnum.APROBADAS;
    } else {
      estado = EstadosSolicitudPeodidoEnum.ABIERTO;
    }


    updateSolicitudesPedidos.mutate(
      {
        id: idEdit!,
        data: {
          estado_solicitud: estado,
          productos: JSON.parse(JSON.stringify((details))),
        },
      },
      {
        onSuccess: () => {
          setIsModalOpen(false);
          setConfirmDialogIsOpen(false);
          setConfirmDialogIsOpen2(false);
          clearProductoSeriesItems();
          clearProductoSinSeriesItems();
          setIsApproved(true);
          handleConfirmMotivoEgreso();
        },
        onError: (error: any) => {
          console.error("Error en la mutación", error);
        },
      }
    );
  };
  const onSaveEdit = () => {
    if (idEdit) {
      const anyQuantityZero = details.some(
        (detail) => Number(detail.cantidad_recibida!) === 0
      );
      if (anyQuantityZero) {
        setConfirmDialog({
          isOpen: true,
          subtitle: "Hay productos con cantidad 0, ¿seguro que deseas enviar?",
          title: "Confirmar envío",
          onConfirm: () => {
            proceedWithSave();
            setConfirmDialogIsOpen2(false);
          },
          onClose: () => {
            setConfirmDialogIsOpen2(false);
          },
        });
        return;
      }
      proceedWithSave();
    };
  }
  const handleConfirmMotivoEgreso = () => {
    setConfirmDialog({
      isOpen: true,
      subtitle: "¿Deseas hacer un egreso?",
      title: "Egreso del producto",
      onConfirm: () => {

        /* console.log('bodega', egreso.bodega)
        console.log('Ubicacion', egreso.ubicacion)
        console.log('productos', details)
        console.log("select Items:", useMaterialesUtilizadosStore.getState().selectedItems) */

        createEgresos.mutate(
          {
            bodega: egreso.bodega,
            ubicacion: egreso.ubicacion,
            
            productos: JSON.parse(JSON.stringify(details)),
            fecha: new Date().toISOString().slice(0, 10),
          } as any,
          {
            onSuccess: () => {
              setConfirmDialogIsOpen(false);
              useMaterialesUtilizadosStore.setState({
                selectedItems: [],
              })
              setIsModalOpen(false);
              refetch();
            },
          }
        );
      },
      onClose() {
        setIsModalOpen(false);
        setConfirmDialogIsOpen(false);
        refetch();
      },
    });
  };


  const columns = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
    () => [
      {
        accessorKey: "detalles",
        header: "Acciones",
        size: 200,
        Cell: ({ row }) => {
          return (
            <>
              <SingleButton
                label="DESPACHAR" 
                variant="text"
                color="success"
                onClick={() => {
                  onDetails(row.original);
                }}
                startIcon={<PendingActionsIcon />}
              />
            </>
          );
        },
      },
      {
        accessorKey: "codigo",
        header: "Codigo",
        size: 200,
        width: 200,
      },
      {
        accessorKey: "numero_referencia",
        header: "referencia",
        size: 200,
      },
      {
        accessorKey: "ubicacion",
        header: "ubicacion",
        size: 200,
        width: 200,
      },
      {
        accessorKey: "user.username",
        header: "usuario",
        size: 200,
        width: 200,
      },
      {
        accessorKey: "bodega",
        header: "bodega",
        size: 200,
      },
      {
        accessorKey: "observaciones",
        header: "observación",
        size: 200,
        width: 200,
      },
      {
        accessorKey: "producto",
        header: "Producto",
        size: 200,
        //Cell: ({ row }) => row.original?.productos?.producto?? 'N/A',
       
      },      
      {
        accessorKey: "estado_solicitud",
        header: "estado",
        size: 200,
        Cell: ({ row }) => (
          row.original.estado_solicitud != null ?
            <EstadoComponente backgroundColor="cyan" texto={row.original.estado_solicitud || ''} /> : null
        ),
      },
    ],
    []
  );
  //HOOK
  const {
    auxRow,
    setAuxRow,
    handleFileExcel,
    handleFileTxt,
    handelValidationSerie,
    handelValidationSerieModal,
    handleAutomatico
  } = useCargarSeries();

  useEffect(() => {
    return () => {
      clearProductoSeriesItems();
      clearProductoSinSeriesItems();

    }
  }, [])

  const onDetails = (e: MRT_RowData) => {
    setEgresos({ bodega: e.bodega, ubicacion: e.ubicacion });

    const aux = JSON.parse(JSON.stringify(e.productos));

    aux.forEach((item: any) => {
      item.producto_data;
      item.series = [];
      item.contieneSeries = false;
      item.contiene_serie = true;
    });
    setDetails(aux);
    addSinSeriesItem(aux, MaterialesKey.solicitudesPedidosSinSeries);

    /*  const detalles = JSON.parse(e.detalles);
     const productosContratados = useMaterialesUtilizadosStore.getState().solicitudesPedidosSinSeries;
     const itemExists = productosContratados.some(i => JSON.stringify(i) === JSON.stringify(detalles));
       if (!itemExists) {
       addSinSeriesItem(detalles, MaterialesKey.solicitudesPedidosSinSeries);
       setAlert(true, 'Item agregado correctamente', 'success');
     } else {
       setAlert(true, 'Ya se encuentra agregado este producto', 'warning');
     }
     */
    setIsModalOpen(true);
    setIdEdit(e.id_solicitudegreso);
  };
  const setAlert = useUiStore((s) => s.setAlert);
  const columnsProductosDetallePedidosDb: MRT_ColumnDef<MaterialTransferido>[] =
    useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
      () => [
        {
          accessorKey: 'codigo',
          header: 'Código',
          Cell: ({ row }) => row.original?.codigo || 'N/A',
        },
        {
          accessorKey: 'descripcion',
          header: 'Descripción',
          Cell: ({ row }) => row.original?.producto_data?.descripcion || 'N/A',
        },
        {
          accessorKey: 'stock_actual',
          header: 'Stock Actual',
          // stock_actual = cantidad transferida
          Cell: ({ row }) => row.original?.producto_data?.stock_actual ?? 'N/A',
        },
        {
          accessorKey: 'producto_data.modelo_producto',
          header: 'Modelo',
        },
        {
          accessorKey: 'producto_data.marca_producto',
          header: 'Marca',
        },
        {
          accessorKey: 'producto_data.categoria_producto',
          header: 'Categoria',
        },
        {
          accessorKey: 'producto_data.unidad_medida',
          header: 'Medida',
        },
        {
          accessorKey: "cantidad",
          header: "Cantidad solicitada",
          size: 100,
        },
       /*  {
          accessorKey: "cantidad_previamente_despachada",
          header: "Cantidad parcialmente despachada",
          size: 100,
        }, */
        /* {
          accessorKey: "cantidad_total",
          header: "Cantidad total a entregar",
          size: 100,
        }, */
        {
          accessorKey: "cantidad_recibida",
          header: "Cantidad a despachar",
          Cell: ({ row }) => {
            return (
              <TextField
                variant="outlined"
                value={row.original.cantidad_recibida ?? ""}
                type="number"
                onKeyDown={(event) => {
                  if (event.key === "e" || event.key === "E") {
                    event.preventDefault();
                  }
                }}
                /* onKeyPress={(event) => {
                  if (event.key === "e" || event.key === "E") {
                    event.preventDefault();
                  }
                }} */
                onChange={(e) => {
                  const value = Number(e.target.value);
                  if (value < 0) {
                    setAlert(
                      true,
                      "La cantidad a despachar no puede ser negativa.",
                      "error"
                    );
                    return;
                  }
                  if (value > Number(row.original.cantidad!)) {
                    setAlert(
                      true,
                      "La cantidad a despachar no puede ser mayor que la cantidad solicitada .",
                      "error"
                    );
                    return;
                  }
                  if (value < Number(row.original.cantidad_acumulada!)) {
                    setAlert(
                      true,
                      "La cantidad a despachar no puede ser menor que la cantidad ya entregada.",
                      "error"
                    );
                    return;
                  }
                  //solo incrementa el valor
                  setDetails((prevState: any) => {
                    const newDetails = prevState.map((detail: any) => {
                      if (detail.id === row.original.id) {
                        const newCantidadPreviamenteDespachada = Math.max(Number(detail.cantidad_previamente_despachada), value);
                        return {
                          ...detail,
                          cantidad_recibida: value.toString(),
                          cantidad_previamente_despachada: newCantidadPreviamenteDespachada.toString(),
                          cantidad_total: (Number(detail.cantidad) - newCantidadPreviamenteDespachada).toString(),
                        };
                      }
                      return detail;
                    });
                    return newDetails;
                  });
                  onChangeQuantity(value, row.original);
                }}
              />
            );
          },
          size: 100,
        },
        {
          accessorKey: 'contiene_serie',
          header: 'Contiene series',
          size: 100,
          enableColumnFilter: false,
          enableSorting: false,
          Cell: ({ row }) => {
            return (
              <Checkbox
                checked={row.original.contiene_serie}
                onChange={(e) => {
                  const value = e.target.checked;
                  setDetails((prevState) => {
                    const newDetails = prevState.map((detail) => {
                      if (detail.id === row.original.id) {
                        return {
                          ...detail,
                          contiene_serie: value,
                        };
                      }
                      return detail;
                    });
                    return newDetails;
                  });
                  onChangeSeries(value, row.original);
                }}
              />
            );
          }
        },
        {
          accessorKey: 'series',
          header: 'Series',
          size: 100,
          enableColumnFilter: false,
          enableSorting: false,
          Cell: ({ row }) => {
            return (
              <Box sx={{ display: 'flex', gap: '1rem' }}>
                <Tooltip title="Cargar Series">
                  <IconButton
                    onClick={async () => {
                      row.original
                      const valido = await handelValidationSerieModal(row.original, form.getValues().ubicacion!);
                      valido && setOpenModalSeries(true);
                    }}
                  >
                    <QrCode2Icon color="primary" />
                  </IconButton>
                </Tooltip>
              </Box>
            );
          }
        },

      ],
      []
    );



  const {
    globalFilter,
    pagination,
    onChangeFilter,
    setPagination,
    //dateBefore,
    //dateAfter,
    onChangeRangeDate,
    cleanFilter, searchTerm
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  const {
    data: solicitudPedidosEnesperaRes,
    isLoading: isLoadingSolicitudesPedidoPaging,
    isRefetching,
    refetch,
  } = useFetchSolicitudesEgreso({
    page_size: pageSize,
    page: pageIndex + 1,
    estado_solicitud: EstadosSolicitudPeodidoEnum.ABIERTO,
    numero_referencia: searchTerm,
    //fecha_after: dateAfter,
    //fecha_before: dateBefore,
  });


  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CustomSearch
          onChange={onChangeFilter}
          value={globalFilter}
          text=""
          onChangeRangeDate={onChangeRangeDate}
          cleanFilter={cleanFilter}
        />
      </Grid>
      <Grid item xs={12}>
        <GeneralTable<SolicitudesEgreso>
          columns={columns}
          data={solicitudPedidosEnesperaRes?.data?.data || []}
          isLoading={isLoadingSolicitudesPedidoPaging}
          isRefetching={isRefetching}
          enableGlobalFilter={false}
          pagination={pagination}
          onPaging={setPagination}
          rowCount={solicitudPedidosEnesperaRes?.data?.count}
          actionsColumnSize={120}
          // crud
          enableColumnActions={false}
          enableEditing={false}
          canDelete={false}
          positionActionsColumn="first"
        />
      </Grid>
       {/* este es para modal de productos */}
      <ScrollableDialogProps
        open={isModalOpen}
        title="Productos"
        onCloseIcon={() => setIsModalOpen(false)}
        cancelTextBtn="Cerrar"
        confirmTextBtn="Aprobar"
        onConfirm={() => onSaveEdit()}
        onClose={() => {
          setIsModalOpen(false);
          clearProductoSeriesItems();
          clearProductoSinSeriesItems();
        }}
        contentNode={
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {details.length > 0 && (
                  <SampleTable<MaterialTransferido>
                    columns={columnsProductosDetallePedidosDb}
                    data={details}
                  />
                )}
              </Grid>
            </Grid>
        }
      />
      {/*MODAL CARGAR SERIES*/}
      <ScrollableDialogProps
        onClose={() => {
          setOpenModalSeries(false);
          setAuxRow({ ...auxRow, series: [] });
          setVisibleComponente({ ...visibleComponente, isArchivo: true });
        }}
        open={openModalSeries}
        title={`CARGAR SERIE - #${auxRow?.producto_data?.codigo}`}
        dialogContentText={texto.selecionar_series}
        minWidth="55%"
        contentNode={
          <Grid container spacing={2} justifyContent={'end'}>
            <Grid item {...gridSizeMdLg3}>
              <ButtonFileComponente
                color={'success'}
                accept={".xls, .xlsx"}
                onChange={e => {
                  setVisibleComponente({ ...visibleComponente, isArchivo: true });
                  handleFileExcel(e);
   
                  e.target.value = "";
                }}
                titulo={"EXCEL"} />

            </Grid>
            <Grid item {...gridSizeMdLg3}>
              <ButtonFileComponente
                color={'info'}
                accept={".txt"}
                onChange={e => {
                  setVisibleComponente({ ...visibleComponente, isArchivo: true });
                  handleFileTxt(e);
                  e.target.value = "";
                }}
                titulo={"TXT"} />
            </Grid>
            <Grid item {...gridSizeMdLg3}>
              <Button size="small"
                style={{
                  color: 'white',
                  background: 'black'
                }}
                onClick={() => {
                  setVisibleComponente({ ...visibleComponente, isArchivo: true });
                  setAuxRow({ ...auxRow, series: [] });
                  handleAutomatico(auxRow?.selected_series!, auxRow.cantidad!)
                }}
                fullWidth variant="outlined">AUTOMATICO</Button>
            </Grid>

            <Grid item {...gridSizeMdLg3}>
              <Button
                fullWidth
                size="small"
                style={{
                  color: 'white',
                  background: 'black'
                }}
                onClick={() => {
                  setAuxRow({ ...auxRow, series: [] });
                  setVisibleComponente({ ...visibleComponente, isArchivo: false });
                }}
              >
                {'MANUAL'}
              </Button>
            </Grid>


            {
              visibleComponente.isArchivo && (
                <>
                  <Grid item xs={12}>
                    <Typography variant="overline">Series Cargadas:</Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <SampleTable<any>
                      density="compact"
                      columns={columnsCargarSeries}
                      data={auxRow?.series || []}
                      enablePagination={true}
                    />

                  </Grid>
                </>
              )
            }

            {/* {
              !visibleComponente.isArchivo && (
                <CustomAutocompleteMultipleArrString
                  label="Series"
                  name="series_all"
                  textFieldKey="series_all"
                  control={form.control as any}
                  defaultValue={[]}
                  options={auxRow.series_all || []}
                  isLoadingData={false}
                  error={undefined}
                  helperText={undefined}
                  disabled={false}
                  enableStringify={false}
                  onChangeValue={value => {
                    if (value && value.length > 0)
                      setAuxRow({ ...auxRow, series: value as string[] })
                  }}
                />
              )
            } */}

            <Grid item>
              <SingleButton
                width="100%"
                label="Guardar"
                onClick={() => {

                  const resp = handelValidationSerie();

                  if (resp) {
                    let aux: MaterialTransferido = { ...auxRow, series: auxRow?.series }
                    delete aux.selected_series;

                    updateSelectedItemQuantity(aux,
                      MaterialesKey.solicitudesPedidosSinSeries
                    );
                    setOpenModalSeries(false);
                    setAlert(true, 'Series Guardados Correctamente', AlertSeverityEnum.success);
                    setVisibleComponente({ ...visibleComponente, isArchivo: true });
                  }

                }}
              >
              </SingleButton>
            </Grid>

          </Grid>
        }
      />
    </Grid>
  );
}